import React from 'react';
import { Card, List, Avatar, Button, Empty, Upload } from 'antd';
import { UserOutlined, SendOutlined } from '@ant-design/icons';

const UserList = ({ users, onSendFile }) => {
  const handleFileSelect = (file, user) => {
    console.log('File selected:', file.name, 'for user:', user.peerId);
    onSendFile(user.peerId, file);
    return false; // Prevent default upload
  };

  return (
    <Card title="Connected Users" style={{ minHeight: '400px' }}>
      {users.length === 0 ? (
        <Empty 
          description="No users connected"
          style={{ margin: '50px 0' }}
        />
      ) : (
        <List
          dataSource={users}
          renderItem={(user) => (
            <List.Item
              actions={[
                <Upload
                  showUploadList={false}
                  beforeUpload={(file) => handleFileSelect(file, user)}
                  accept="*"
                >
                  <Button
                    type="primary"
                    icon={<SendOutlined />}
                    size="small"
                  >
                    Send File
                  </Button>
                </Upload>
              ]}
            >
              <List.Item.Meta
                avatar={
                  <Avatar 
                    style={{ backgroundColor: '#87d068' }}
                    icon={<UserOutlined />}
                  />
                }
                title={user.username || `User ${user.peerId.slice(0, 6)}`}
                description={`ID: ${user.peerId.slice(0, 12)}...`}
              />
            </List.Item>
          )}
        />
      )}
    </Card>
  );
};

export default UserList;